// test1036
(1036 && 0);
